import React from "react";
import styled from "styled-components";

const MessageBox = ({ message, onClose }) => {
  const handleClose = () => {
    if (onClose) onClose();
  };
  return (
    <StyledOverlay
      visible={message !== undefined && message !== null && message !== ""}
    >
      <StyledMessagePanel>
        <StyledCloseButton onClick={handleClose}>
          <span
            className="iconmford fo-icon-close"
            style={{ fontSize: "20px", marginRight: "0px" }}
          ></span>
        </StyledCloseButton>
        <StyledMessage>{message}</StyledMessage>
      </StyledMessagePanel>
    </StyledOverlay>
  );
};

export default MessageBox;

const StyledOverlay = styled.div`
  background: #dddddd80;
  display: ${(props) => (props.visible ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

const StyledMessagePanel = styled.div`
  background: #fff;
  padding: 24px;
  color: #000;
  max-width: 480px;
`;

const StyledCloseButton = styled.button`
  position: relative;
  top: -40px;
  right: -16px;
  float: right;
  background: #fff;
  border: none;
  padding: 0;
  border-radius: 50%;
  height: 32px;
  width: 32px;
  color: #012f6d;
  font-size: 24px;
`;

const StyledMessage = styled.span`
  color: #012f6d;
  font-size: 16px;
`;
